var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"row mt-4"},[_c('img',{staticClass:"col-sm-5",attrs:{"src":require('@/assets/' + _vm.img + ''),"alt":""}}),_c('div',{staticClass:"col-sm-6 mt-4"},[_c('h2',{staticClass:"mb-4"},[_vm._v(_vm._s(_vm.title))]),_c('p',{staticClass:"mt-4"},[_vm._v(_vm._s(_vm.text1))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }